export const getAppointmentLoading = state => state.appointmentR.isLoading;
export const getAppointmentData = state => state.appointmentR.serviceCalendar;
export const getStoreClient = state => state.appointmentR.storeClient;
export const getCalendarIdLoading = state => state.appointmentR.isCalendarIdLoading;
export const getSingleCalendar = state => state.appointmentR.singleServiceCalendar;